import { apiClient } from "../apiClient";
import { IXetTotNghiepRequest } from "../../model/request/xet-tot-nghiep/IXetTotNghiepRequest";

export const XET_TOT_NGHIEP_ENDPOINT = "xet-tot-nghiep";
export const xetTotNghiepApi = {
    xetTotNghiep: (request: IXetTotNghiepRequest, progress_id: string) => apiClient.post(`${XET_TOT_NGHIEP_ENDPOINT}/xet?progress_id=${progress_id}`, request), 
    xetKetQuaHocTap: (request: IXetTotNghiepRequest, progress_id: string) => apiClient.post(`${XET_TOT_NGHIEP_ENDPOINT}/xet-ket-qua-hoc-tap?progress_id=${progress_id}`, request), 
    xetChungChi: (request: IXetTotNghiepRequest, progress_id: string) => apiClient.post(`${XET_TOT_NGHIEP_ENDPOINT}/xet-chung-chi?progress_id=${progress_id}`, request), 
}